module.exports = __webpack_public_path__ + "img/returnUnit.7ad4a84c.gif";